module.exports = __webpack_public_path__ + "img/shuffle-inactive.a8a42951.svg";